import React from 'react';
import styled from '@emotion/styled';
import { Blinker } from 'core/models/drive';
import { BlinkerButton } from 'components/views/atoms/BlinkerButton';

const Box = styled.div({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    ['> *']: {
        width: '30%',
    },
});

export type BlinkerBoxProps = {
    blinker: Blinker | null;
    onSelect: (value: Blinker | null) => void;
}

export const BlinkerBox = (props: BlinkerBoxProps) => {
    const blinkers = [Blinker.Left, Blinker.Hazard, Blinker.Right];

    return (
        <Box>
            {
                blinkers.map(b =>
                    <BlinkerButton key={b}
                        blinker={b} selected={props.blinker == b}
                        onClick={() => props.onSelect(props.blinker == b ? null : b)} />
                )
            }
        </Box>
    );
};
